import { render, staticRenderFns } from "./Dividends.vue?vue&type=template&id=4ac3791c&scoped=true"
import script from "./Dividends.vue?vue&type=script&lang=js"
export * from "./Dividends.vue?vue&type=script&lang=js"
import style0 from "./Dividends.vue?vue&type=style&index=0&id=4ac3791c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac3791c",
  null
  
)

export default component.exports